import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../../components/Header";
import { AssetFinanceUrl } from "../../../../config";
import { executeDynamicSubmit } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const Form = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const initialValues = {
    code: props.data ? props.data.Code : "",
    name: props.data ? props.data.Name : "",
    description: props.data ? props.data.Description : "",
    governingAuthority: props.data ? props.data.GoverningAuthority : "",
    governingStatute: props.data ? props.data.GoverningStatute : "",
    typicalRegistrationFee: props.data ? props.data.TypicalRegistrationFee : "",
    typicalDischargeFee: props.data ? props.data.TypicalDischargeFee : "",
    displayOrder: props.data ? props.data.DisplayOrder : "",
    isActive: props.data ? !!props.data.IsActive : true,
  };

  const validationSchema = yup.object().shape({
    code: yup.string().required("Code is required"),
    name: yup.string().required("Name is required"),
    description: yup.string().nullable(),
    governingAuthority: yup.string().nullable(),
    governingStatute: yup.string().nullable(),
    typicalRegistrationFee: yup.number().typeError("Enter a valid number").nullable(),
    typicalDischargeFee: yup.number().typeError("Enter a valid number").nullable(),
    displayOrder: yup.number().typeError("Enter a valid number").nullable(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const registry = {
      code: values.code,
      name: values.name,
      description: values.description || "",
      governingAuthority: values.governingAuthority || "",
      governingStatute: values.governingStatute || "",
      typicalRegistrationFee: values.typicalRegistrationFee
        ? parseFloat(values.typicalRegistrationFee)
        : null,
      typicalDischargeFee: values.typicalDischargeFee
        ? parseFloat(values.typicalDischargeFee)
        : null,
      displayOrder: values.displayOrder ? parseInt(values.displayOrder) : 0,
      companyId: parseInt(decodedToken.CompanyId),
      isActive: values.isActive,
    };

    if (props.isEditing) {
      registry.id = props.data.Id;
    }

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateRegistry" : "createRegistry",
      variables: registry,
      mutationObjectName: "registry",
      baseUrl: base_url,
      isEditing: props.isEditing,
      entityName: "Registry",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Registry" : "Create Registry"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Collateral Registry"
            : "Create a New Collateral Registry"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Code*"
                placeholder="e.g. NTSA"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                name="code"
                error={touched.code && !!errors.code}
                helperText={touched.code && errors.code}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Name*"
                placeholder="e.g. National Transport and Safety Authority"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                multiline
                minRows={2}
                variant="filled"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Governing Authority"
                placeholder="e.g. Ministry of Transport"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.governingAuthority}
                name="governingAuthority"
                error={touched.governingAuthority && !!errors.governingAuthority}
                helperText={touched.governingAuthority && errors.governingAuthority}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Governing Statute"
                placeholder="e.g. NTSA Act Section 4"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.governingStatute}
                name="governingStatute"
                error={touched.governingStatute && !!errors.governingStatute}
                helperText={touched.governingStatute && errors.governingStatute}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Typical Registration Fee"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.typicalRegistrationFee}
                name="typicalRegistrationFee"
                error={touched.typicalRegistrationFee && !!errors.typicalRegistrationFee}
                helperText={touched.typicalRegistrationFee && errors.typicalRegistrationFee}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Typical Discharge Fee"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.typicalDischargeFee}
                name="typicalDischargeFee"
                error={touched.typicalDischargeFee && !!errors.typicalDischargeFee}
                helperText={touched.typicalDischargeFee && errors.typicalDischargeFee}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Display Order"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.displayOrder}
                name="displayOrder"
                error={touched.displayOrder && !!errors.displayOrder}
                helperText={touched.displayOrder && errors.displayOrder}
                sx={{ gridColumn: "span 2" }}
              />
              <Box sx={{ gridColumn: "span 4", display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.isActive}
                      onChange={(e) => setFieldValue("isActive", e.target.checked)}
                    />
                  }
                  label="Active"
                />
              </Box>
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Form;
